import React from "react";

export default function Footer({ googleWriteReview, sponsors, social }) {
  const { spBelgium, spAdepsFWB, spJudoWB, spKoekelberg } = sponsors;

  return (
    <footer className="footer">
      <section id="avis" className="section">
        <div className="container">
          <div className="reviews-head">
            <span className="section-label" style={{ background: "rgba(245,197,24,0.15)", color: "var(--brand)" }}>⭐ Avis</span>
            <h2 className="section-title" style={{ color: "#fff" }}>Ce que disent nos membres</h2>
            <p style={{ color: "rgba(255,255,255,0.5)", marginTop: 4 }}>Ton avis nous aide à grandir. Merci pour ton retour !</p>
          </div>

          <div className="reviews-cta">
            <a className="btn-review" href={googleWriteReview} target="_blank" rel="noreferrer">
              <i className="fa-brands fa-google" />
              Laisser un avis sur Google
            </a>
          </div>
        </div>
      </section>

      <div className="container">
        {social && (
          <div className="foot-social">
            <a href={social.fb} target="_blank" rel="noreferrer" aria-label="Facebook">
              <i className="fa-brands fa-facebook-f" />
            </a>
            <a href={social.ig} target="_blank" rel="noreferrer" aria-label="Instagram">
              <i className="fa-brands fa-instagram" />
            </a>
            <a href={social.tt} target="_blank" rel="noreferrer" aria-label="TikTok">
              <i className="fa-brands fa-tiktok" />
            </a>
            <a href={social.wa} target="_blank" rel="noreferrer" aria-label="WhatsApp">
              <i className="fa-brands fa-whatsapp" />
            </a>
          </div>
        )}

        <div className="sponsor-strip" aria-label="Sponsors et partenaires">
          <span className="sponsor-label">Avec le soutien de</span>
          <ul className="sponsor-logos">
            <li><img src={spBelgium} alt="Royaume de Belgique" loading="lazy" /></li>
            <li><img src={spAdepsFWB} alt="Adeps – Fédération Wallonie-Bruxelles" loading="lazy" /></li>
            <li><img src={spJudoWB} alt="Judo Wallonie-Bruxelles" loading="lazy" /></li>
            <li><img src={spKoekelberg} alt="Commune de Koekelberg" loading="lazy" /></li>
          </ul>
        </div>

        <div className="foot-bottom">
          <span>© {new Date().getFullYear()} <b>Wolves Bruxelles</b></span>
          <span className="foot-sep">·</span>
          <span>Rue Léon Autrique 4, 1081 Koekelberg</span>
        </div>
      </div>
    </footer>
  );
}
